import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=64451eaa&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=64451eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64451eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64451eaa')) {
      api.createRecord('64451eaa', component.options)
    } else {
      api.reload('64451eaa', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=64451eaa&scoped=true&", function () {
      api.rerender('64451eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22J9akXhfqEUQ/JS/comp/DateRangeExt.vue"
export default component.exports